"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventrDateFromStringSchema = exports.SerialisedEventrDateSchema = void 0;
const zod_1 = require("zod");
const date_1 = require("../date/date");
exports.SerialisedEventrDateSchema = zod_1.z.object({
    timestamp: zod_1.z.number(),
    timezone: zod_1.z.string().optional(),
});
exports.EventrDateFromStringSchema = zod_1.z.string().transform((dateString) => {
    const eventrDate = new date_1.EventrDate(dateString);
    const serialisedEventrDate = {
        timestamp: eventrDate.getUnixMs,
        timezone: eventrDate.itinLocalLuxon.zoneName, // N.B., using `itinLocalLuxon` respects any overrides and the itinerary's timezone.
    };
    return serialisedEventrDate;
});
